module.exports = __webpack_public_path__ + "static/media/reactjs-line.ec8c0820.svg";